import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
interface MessageStatusChangeResponse {
  patientIds: string[];
  userIds: number[];
}

interface MessageStatusChangeParams {
  userId?: string;
  patientId?: string;
  statusChangeAction: MessageStatus;
}

export enum MessageStatus {
  MARK_READ = "mark_read",
  MARK_UNREAD = "mark_unread",
  MARK_ARCHIVED = "mark_archived",
  MARK_INBOXED = "mark_inboxed",
}

export const useMessageStatusChange = (patientId: string) => {
  const queryClient = useQueryClient();

  return useApiMutation<MessageStatusChangeResponse, MessageStatusChangeParams>(
    {
      mutationOptions: {
        mutationKey:
          QueryKeys.Provider.AsyncMessageDashboard.STATUS_CHANGE(patientId),
        mutationFn: (params) =>
          axiosInstance.post(
            "/new-api/async-messaging/notifications/status-change",
            params,
          ),
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: QueryKeys.Provider.AsyncMessageDashboard.INBOX,
          });
          queryClient.invalidateQueries({
            queryKey: QueryKeys.Provider.AsyncMessageDashboard.ARCHIVE,
          });
        },
      },
    },
  );
};
